import React from 'react';

export default class LoadFooter extends React.PureComponent {
  componentDidMount() {
    try {
      // eslint-disable-next-line no-undef
      web.loadWebFooter(this.instance);
    } catch (error) {
      console.log(error);
    }
  }

  render() {
    return (
      <div ref={(el) => { this.instance = el; }} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/global/Footer/index.js